<template>
  <div>
    <!-- 로그인 박스 -->
    <form id="signupForm" v-on:submit.prevent="onSubmit(userId, userPwd, solCd);" class="signUp">
      <h1 class="signUpTitle">경영지원플랫폼
        <span>클라이언트 가치 향상에 기여하는 혁신적인 플랫폼</span>
      </h1>
      <input v-validate="'required|email'" data-vv-validate-on="change" type="text" name="email" class="signUpInput" v-model="userId" placeholder="ID" autofocus required maxlength="50">
      <input v-validate="'required|min:6'" data-vv-validate-on="change" type="password" name="password" class="signUpInput" v-model="userPwd" placeholder="Password" required maxlength="50">
      <div class="status"></div>
      <input type="hidden" v-model="solCd">
      <div class="form-group">
        <span class="form-remember">
          <label class="myCheckbox">
            <input type="checkbox" name="all" v-model="checked"/>
            <span></span>
            아이디 기억하기
          </label>
        </span>
        <span class="tr">
          <router-link :to="{ name: 'FindAccount', params: {prop_active: 0 } }" tag="a" class="form-recovery">아이디 찾기
          </router-link>
          I
          <router-link :to="{ name: 'FindAccount', params: {prop_active: 2 } }" tag="a" class="form-recovery">비밀번호 변경
          </router-link>
        </span>
      </div>
      <span v-for="group in errors.collect()">
        <span v-for="error in group" class="stext">
          <span class="k-icon k-i-warning"></span>
          {{ error }}
        </span>
      </span>
      <input type="submit" value="로그인" class="signUpButton">
      <p>시스템 사용문의 : 1533-4810(내선 9102)</p>
    </form>
    <!-- //로그인박스 -->
    <!-- 로그인푸터 -->
  </div>
</template>


<script>
  import { mapState } from 'vuex'
  import util from '@/common/util'

  export default {
    name    : 'Login',
    data () {
      return {
        userId : window.localStorage.getItem('savedUserId'),
        userPwd: null,
        solCd  : null,
        checked: null,
      }
    },
    mounted () {
      let savedUserId = util.getUserSavedId()
      let existSavedUserIdFl = false
      if (savedUserId !== '' && savedUserId != null) {
        existSavedUserIdFl = true
      }
      this.checked = existSavedUserIdFl
    },
    methods : {
      onSubmit (userId, userPwd, solCd) {
        console.log(`onSubmit !!`)
        this.$validator.validateAll().then((result) => {
          if (result) {
          	//만약 여러번 로그인이 수행되었을 경우를 대비해서 기존 데이터를 삭제한다.
          	sessionStorage.removeItem('userInfo')
      		sessionStorage.removeItem('isFirstLogin')


            // id 기억하기가 체크 시 localstorage 저장
            if (this.checked) {
              util.saveUserId(userId)
            } else {
              util.destroyUserId(userId)
            }

            const loginParam = {
              userId: userId,
              userPwd: userPwd,
              solCd: '0000',
              workspaceCd:'01'
            }

            this.$store.dispatch('FETCH_LOGIN', loginParam)

              // 성공시 메인으로 이동
              .then(data => {
                console.log(`data : ${JSON.stringify(data)}`)

                 // if (data.resultData.firstLoginYn === 'Y') {
                    this.$router.push(
                      {
                        name: 'FirstLoginForm',
                      },
                    )
              /*    } else {
                    const solCd = data.resultData.solCd
                    let isExist = (solCd.indexOf("0000")!== -1)
                    console.log(this.$store.state.loginStore.isAuthenticated)
                  /!*  if(isExist){
                      this.$router.push({ name: 'Main' })
                    }else {
                      this.$router.push({name: 'Concierge'})
                    }*!/
                  }*/

                },
              )
          }
        })

      },

    },
    computed: {
      ...mapState({
        loginErrors: state => state.loginStore.loginErrors,
      }),
    },
  }
</script>

<style>
</style>
